import React, { useState } from 'react';
import styled from 'styled-components';
import { Menu } from '~/pages/components/ui/menu';

type IProps = {
  children?: React.ReactNode;
  $menuWithLogo?: boolean;
  $withoutMenu?: boolean;
};

function Main(props: IProps) {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const { children, $menuWithLogo, $withoutMenu } = props;

  function handleMenuClick() {
    setIsMenuOpen(!isMenuOpen);
  }

  function handleClose() {
    setIsMenuOpen(false);
  }

  return (
    <MainContainer {...props}>
      {!$withoutMenu && (
        <Menu
          close={handleClose}
          $menuWithLogo={$menuWithLogo}
          isOpen={isMenuOpen}
          onClick={handleMenuClick}
        />
      )}

      <SContent>{children}</SContent>
    </MainContainer>
  );
}

export default Main;

const MainContainer = styled.main`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  aspect-ratio: 16/27;
  height: 100%;
  @media screen and (max-aspect-ratio: 16/27) {
    width: 100%;
  }
  @media screen and (min-aspect-ratio: 16/27) {
    overflow: hidden;
  }
`;

const SContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 42px);
  justify-content: center;
  width: 100%;
`;
